import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { getters, actions } from "../../../model";

import { Div, Text5, CloseIcon, BigFilledButton } from "components/Base";

import Loading from "ui-kit/Loading";

import { WithFormInstanceProvider } from "ui-kit/Form/View";
import { CLASSY_FORM_ID } from "../../../constants";
import {
  getIntegrationName,
  getIntegrationObjectName,
  getLenndEvents,
  getCampaigns,
  getExistingMappings,
  getIsMappingValid
} from "../../../selectors";

import MiniModalWrapper from "ui-kit/MiniModalWrapper";
import { noop } from "utils/General";

import CSSModules from "react-css-modules";
import css from "../../styles.scss";

const Header = ({ title = "", hideModal = noop }) => (
  <Div
    style={{
      flexShrink: 0
    }}
    display="row.space-between.center"
    bg="white"
    p={4}
    bb={1}
    bc="neutral2"
    brt={1}
  >
    <Text5 bold color="neutral8">
      {title}
    </Text5>

    <Div onClick={hideModal}>
      <CloseIcon color="neutral6" sizeWFS={6} />
    </Div>
  </Div>
);

const decorate = R.compose(
  WithFormInstanceProvider(R.always(CLASSY_FORM_ID)),
  CSSModules(css),
  connect(
    (state, props) => ({
      showModal: getters.isHubspotModalOpen(state, props),
      data: getters.data(state),
      error: getters.error(state),
      loading: getters.loadingMappings(state),
      syncing: getters.syncing(state),
      integrationName: getIntegrationName(state),
      objectName: getIntegrationObjectName(state),
      lenndEvents: getLenndEvents(state),
      campaigns: getCampaigns(state),
      existingMappings: getExistingMappings(state),
      isValid: getIsMappingValid(state)
    }),
    {
      hideModal: () => actions.setIsHubspotModalOpen(false),
      saveCampaignMappings: actions.saveCampaignMappings,
      setSelectedCampaignId: actions.setSelectedCampaignId,
      setSelectedEventId: actions.setSelectedEventId,
      removeMapping: actions.removeMapping,
      syncHubspotEvent: actions.syncHubspotEvent
    }
  )
);

const Modal = ({
  showModal,
  hideModal = noop,
  saveCampaignMappings = noop,
  setSelectedCampaignId = noop,
  setSelectedEventId = noop,
  removeMapping = noop,
  syncHubspotEvent = noop,
  integrationName,
  objectName = "Campaign",
  data,
  error,
  loading,
  syncing,
  lenndEvents = [],
  campaigns = [],
  existingMappings = [],
  isValid
}) => (
  <MiniModalWrapper
    hideModal={hideModal}
    isPortal={false}
    showModal={showModal}
    showHeader={false}
    style={{
      width: 550,
      backgroundColor: "white",
      height: "auto",
      maxHeight: "500px"
    }}
    bg="neutral0"
  >
    <Header title={`Sync Your Events to Hubspot`} hideModal={hideModal} />
    <Div
      width={1}
      height={1}
      p={4}
      display="column.flex-start.stretch"
      bb={1}
      bg="neutral0"
      bc="neutral1"
      shadow={1}
      style={{ overflowY: "auto", flex: "1 1 auto" }}
    >
      {loading ? (
        <Loading />
      ) : (
        <Div width={1} display="column" width={1}>
          {lenndEvents.length ? (
            <Div>
              <Div fs={3} fw={3} mb={2} color="black">
                Your Events:
              </Div>
              {lenndEvents.map(m => (
                <Div display="column" width={1} px={2} py={2} bb={1} bc="gray3">
                  <Div display="row.flex-start.center">{m.label}</Div>
                  <Div display="row.flex-start.center">
                    <Div
                      fs={2}
                      color="primary7"
                      onClick={
                        syncing === m.value
                          ? () => {}
                          : () =>
                              syncHubspotEvent({
                                eventId: m.value
                              })
                      }
                    >
                      {syncing === m.value
                        ? "Syncing..."
                        : "Sync Registrations"}
                    </Div>
                  </Div>
                </Div>
              ))}
            </Div>
          ) : null}
        </Div>
      )}
    </Div>
    <Div
      bg="white"
      width={1}
      display="column.flex-start.stretch"
      p={4}
      bt={1}
      bc="neutral2"
    >
      {error && error.length ? (
        <Div
          bra={1}
          bg="danger3"
          p={1}
          mb={1}
          fs={1}
          color="black"
          display="row.center.center"
        >
          {error}
        </Div>
      ) : null}
      <BigFilledButton
        bg="altB5"
        color="white"
        width={1}
        display="row.center.center"
        onClick={hideModal}
      >
        Done
      </BigFilledButton>
    </Div>
  </MiniModalWrapper>
);

export default decorate(Modal);
